import { RowProps } from "./Grid.types";

export function Row({ children }: RowProps) {
  return <div className="row">{children}</div>;
}
